// source: design/src/components/Header.tsx + design/src/components/Footer.tsx (export 2026-04-24)
export default {
  navList: [
    {
      id: 'products',
      title: '产品与服务',
      link: '/products',
      subNav: [
        { title: 'IFS 解决方案', link: '/services_ifs-solution' },
        { title: 'SI 系统集成', link: '/services_system-integration' },
        { title: '机器人解决方案', link: '/services_robot-solution' },
        { title: 'UI/UX 设计 & 开发', link: '/services_uiux-design' },
      ],
    },
    {
      id: 'work-cards',
      title: '客户案例',
      link: '/works',
      subNav: [],
    },
    { title: 'logo', link: '' },
    {
      id: 'home-about',
      title: '关于我们',
      link: '/home-about',
      subNav: [
        { title: '飞狼数码（上海）有限公司', link: '/about_sh' },
        { title: '成都市飞狼科技有限公司', link: '/about_cd' },
        { title: '大连飞狼科技有限公司', link: '/about_dl' },
      ],
    },
    {
      id: 'recruit',
      title: '招贤纳才',
      link: '/recruit',
      subNav: [],
    },
    {
      id: 'news',
      title: '企业动态',
      link: '/news',
      subNav: [],
    },
  ],
  productsMenu: {
    ifs: {
      title: 'IFS 解决方案',
      desc: '端到端数字化系统集成服务',
      link: '/ifs',
      children: [
        { title: 'ERP 企业资源计划', link: 'https://www.ifs.com/en/products/erp' },
        { title: 'EAM 企业资产管理', link: 'https://www.ifs.com/en/products/alm/eam' },
        { title: 'FSM 现场服务管理', link: 'https://www.ifs.com/en/products/fsm' },
        { title: '企业 AI 解决方案', link: 'https://www.ifs.com/en/products/ai' },
      ],
    },
    si: {
      title: 'SI 系统集成',
      desc: '打通系统与数据构建高效协同',
      link: '/si',
      children: [
        { title: 'MES 制造执行系统', link: '/si/mes' },
        { title: 'WMS 仓储管理系统', link: '/si/wms' },
        { title: 'AI', link: '/si/ai' },
      ],
    },
    rb: {
      title: '机器人',
      desc: 'IoT & 机器人解决企业检测方案',
      link: '/robot',
    },
    uiux: {
      title: 'UI/UX 设计 & 开发',
      desc: '以用户为中心的数字体验设计与开发',
      link: '/uiux',
    },
  },
  privacy_link: '隐私政策',
  information_security_link: '信息安全基本方针',
  beianIcp: '蜀 ICP 备 19005068 号',
  beian: '川公网安备 51019002002138 号',
  langList: [
    { title: '中文', code: 'zh' },
    { title: '日本語', code: 'ja' },
  ],
  contact: {
    title: '联系方式',
    emailTitle: '邮箱',
    url: 'info@fenrir-inc.com.cn',
    telTitle: '电话',
    tels: ['021-33639028（上海）', '028-85177409（成都）', '0411-83731889（大连）'],
    contactTitle: '联系我们',
  },
};
